module.exports = {"id":"240896","name":"Christian Alemán","rating":"73","photo":"./data/images/photos/1/240896.png","club":{"name":"Estudiantes","logo":"./data/images/clubs/Estudiantes.png"},"positions":["MG","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianAleman0.json
// module id = 783
// module chunks = 0